import type { SVGProps } from 'react';
const SvgViewInAr = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_in_ar_svg__a)">
      <path
        fill="currentColor"
        d="m18.25 7.6-5.5-3.18a1.49 1.49 0 0 0-1.5 0L5.75 7.6c-.46.27-.75.76-.75 1.3v6.35c0 .54.29 1.03.75 1.3l5.5 3.18c.46.27 1.04.27 1.5 0l5.5-3.18c.46-.27.75-.76.75-1.3V8.9c0-.54-.29-1.03-.75-1.3ZM7 14.96v-4.62l4 2.32v4.61l-4-2.31Zm5-4.03L8 8.61l4-2.31 4 2.31-4 2.32Zm1 6.34v-4.61l4-2.32v4.62l-4 2.31ZM7 2H3.5C2.67 2 2 2.67 2 3.5V7h2V4h3V2Zm10 0h3.5c.83 0 1.5.67 1.5 1.5V7h-2V4h-3V2ZM7 22H3.5c-.83 0-1.5-.67-1.5-1.5V17h2v3h3v2Zm10 0h3.5c.83 0 1.5-.67 1.5-1.5V17h-2v3h-3v2Z"
      />
    </g>
    <defs>
      <clipPath id="view_in_ar_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewInAr;
